module.exports = __webpack_public_path__ + "static/img/share.3f92be25.png";